import Container from '../../Basic/Container/Container.mjs';
import Heading from '../../Typography/Heading/Heading.mjs';
import styled, { css } from 'styled-components';

const StyledImageContainer = styled.div `
  position: relative;
  height: 200px;
  width: 100%;
  margin: 0 0 1.5rem;
`;
const StyledContainer = styled(Container) `
  max-width: 900px;
  margin: 0 auto;
  padding: 0 1rem;

  @media (min-width: ${props => props.theme.breakpoints.sm}) {
    text-align: center;
  }
`;
const resetMargin = css `
  margin: 0;
`;
const StyledHeading = styled(Heading) `
  ${resetMargin}
`;

export { StyledContainer, StyledHeading, StyledImageContainer };
//# sourceMappingURL=CategoryTitleSection.styles.mjs.map
